import _ from 'lodash';
import * as client from '../api/contentful-client';
import * as actions from '../actions/product';

export const fetchReviewsPage = () => ({
  promise: () => client.getPage('yotpo-reviews-page'),
  events: ['PROMISE_PENDING', actions.SET_REVIEWS_PAGE, 'PROMISE_ERROR'],
});

export const fetchCustomerGalleryPage = () => ({
  promise: () => client.getPage('customer-gallery-page'),
  events: ['PROMISE_PENDING', actions.SET_CUSTOMER_GALLERY_PAGE, 'PROMISE_ERROR'],
});

export const fetchGlowforgeProductsPage = (productId) => {
  const pageId = _.isNil(productId) ? 'glowforge-products-page' : `glowforge-${productId}-product-page`;
  return {
    promise: () => client.getPage(pageId),
    events: ['PROMISE_PENDING', actions.SET_GLOWFORGE_PRODUCTS_PAGE, 'PROMISE_ERROR'],
  };
};

export const fetchManualPage = () => ({
  promise: () => client.getPage('manual-page'),
  events: ['PROMISE_PENDING', actions.SET_MANUAL_PAGE, 'PROMISE_ERROR'],
});



// WEBPACK FOOTER //
// ./app/api/product-api.js